import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const ProgressivePlansComponent = Loadable(() => import('../containers/index'));

export default MapTo('vcg/components/soe-home/react/progressiveplans')(ProgressivePlansComponent);
